import "@mantine/core/styles.css";
import {Links, Meta, Scripts, ScrollRestoration, type MetaFunction} from "react-router";
import {AppShell, MantineProvider} from "@mantine/core";

import {CsrfTokenApp} from "@digisthesia/remix-utils/csrf-token";
import {csrfTokenLoader, rootMiddlewares} from "@digisthesia/remix-utils/helpers.server";

//local
import {HexploitTheme} from "~/mantine-theme";
import {Footer} from "~/components/footer";
import {AppNav} from "~/components/nav";
import "./styles.css";

export function Layout({children}: {children: React.ReactNode}) {
  return (
    <html>
      <head>
        <Meta />
        <Links />
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-Z9C7RLD1LZ"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-Z9C7RLD1LZ');
              `,
          }}
        />
      </head>
      <body>
        <MantineProvider theme={HexploitTheme}>
          <AppShell padding={0} header={{height: 84}}>
            <AppShell.Header>
              <AppNav />
            </AppShell.Header>
            <AppShell.Main>{children}</AppShell.Main>
            <AppShell.Footer pos="static">
              <Footer />
            </AppShell.Footer>
          </AppShell>
        </MantineProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export const loader = csrfTokenLoader;
export const middleware = rootMiddlewares;
export const meta: MetaFunction = () => [
  {title: "Hexploit - et si créer des histoires devenait un jeu ?"},
  {name: "viewport", content: "width=device-width, initial-scale=1"},
];
export default CsrfTokenApp;
